import { render, staticRenderFns } from "./DeleteCoupon.vue?vue&type=template&id=6f37e464&scoped=true"
import script from "./DeleteCoupon.vue?vue&type=script&lang=js"
export * from "./DeleteCoupon.vue?vue&type=script&lang=js"
import style0 from "./DeleteCoupon.vue?vue&type=style&index=0&id=6f37e464&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37e464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f37e464')) {
      api.createRecord('6f37e464', component.options)
    } else {
      api.reload('6f37e464', component.options)
    }
    module.hot.accept("./DeleteCoupon.vue?vue&type=template&id=6f37e464&scoped=true", function () {
      api.rerender('6f37e464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/conventional/dialogs/DeleteCoupon.vue"
export default component.exports